import { render, staticRenderFns } from "./ExtraDetail.vue?vue&type=template&id=19534b5c&"
import script from "./ExtraDetail.vue?vue&type=script&lang=js&"
export * from "./ExtraDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports